declare const __APP_VERSION__: string

export function getAppVersion(): string {
  return __APP_VERSION__
}
